import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Card from '../../../components/ui/Card';

const OccupancyTrendChart = ({ data }) => {
  return (
    <Card className="p-6">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-foreground mb-2">Occupancy Trend</h2>
        <p className="text-sm text-muted-foreground">
          Historical occupancy rate over the last 6 months
        </p>
      </div>
      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis dataKey="month" stroke="#6b7280" />
          <YAxis stroke="#6b7280" domain={[0, 100]} tickFormatter={(value) => `${value}%`} />
          <Tooltip
            formatter={(value, name) => {
              if (name === 'Occupancy Rate') return `${value}%`;
              return value;
            }}
            contentStyle={{
              backgroundColor: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px'
            }}
          />
          <Legend />
          <Line
            type="monotone"
            dataKey="occupancyRate"
            stroke="#1877F2"
            strokeWidth={3}
            name="Occupancy Rate"
            dot={{ fill: '#1877F2', r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
        {data?.slice(-1)?.map((latest, index) => (
          <React.Fragment key={index}>
            <div className="p-4 bg-blue-50 rounded-lg">
              <p className="text-sm font-medium text-muted-foreground mb-1">Current Rate</p>
              <p className="text-2xl font-bold text-blue-600">{latest?.occupancyRate}%</p>
            </div>
            <div className="p-4 bg-green-50 rounded-lg">
              <p className="text-sm font-medium text-muted-foreground mb-1">Occupied</p>
              <p className="text-2xl font-bold text-green-600">{latest?.occupied}</p>
            </div>
            <div className="p-4 bg-yellow-50 rounded-lg">
              <p className="text-sm font-medium text-muted-foreground mb-1">Vacant</p>
              <p className="text-2xl font-bold text-yellow-600">{latest?.vacant}</p>
            </div>
            <div className="p-4 bg-gray-50 rounded-lg">
              <p className="text-sm font-medium text-muted-foreground mb-1">Total Units</p>
              <p className="text-2xl font-bold text-gray-900">{latest?.total}</p>
            </div>
          </React.Fragment>
        ))}
      </div>
    </Card>
  );
};

export default OccupancyTrendChart;